var map = {
	"./adult/nn/readingtest-text.js": 818,
	"./adult/no/readingtest-text.js": 819,
	"./adult/se/readingtest-text.js": 820,
	"./youth/de/readingtest-text.js": 821,
	"./youth/nn/readingtest-text.js": 822,
	"./youth/no/readingtest-text.js": 823,
	"./youth/se/readingtest-text.js": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;